/**
 * Handle button in CKEditor
 *
 * @param container {HTMLElement} data atribut element
 */

const ButtonKentico = (element) => {
  if (element.dataset.buttonlink) {
    element.href = element.dataset.buttonlink;
  }
};

export default ButtonKentico;
